<template>
  <!-- UserEdit -->
  <b-modal
    id="modalEdit"
    title="Edit User"
    size="1.714rem"
    ok-title="Accept"
    cancel-title="Close"
    @ok="editInfo"
  >
    <b-row>
      <!-- First name -->
      <b-col cols="12">
        <b-form-group
          label="First name"
          label-for="firstname"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="UserIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="firstname"
              v-model="editData.firstname"
              type="text"
              placeholder="First name"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- LAST NAME -->
      <b-col cols="12">
        <b-form-group
          label="Last Name"
          label-for="lastname"
        >
          <b-input-group class="input-group-merge">
            <!-- <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend> -->
            <b-form-input
              id="lastname"
              v-model="editData.lastname"
              type="text"
              placeholder="Last Name"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- DEPARTMENT -->
      <b-col cols="12">
        <b-form-group
          label="Role"
          label-for="role"
        >
          <v-select
            v-model="editData.role"
            :reduce="role => role.GroupName"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="GroupDescription"
            :options="role"
            transition=""
          />
        </b-form-group>
      </b-col>

      <template #code>
        {{ codeFeedbackHelper }}
      </template>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BInputGroup, BFormInput, BInputGroupPrepend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    vSelect,
    BInputGroupPrepend,
  },
  data() {
    return {
      role: [],
      editData: {
        id: '',
        firstname: '',
        lasttname: '',
        role: '',
        groupname: '',
      },
      selectedUser: '',
    }
  },
  mounted() {
    this.dropdownRole()
  },
  methods: {
    // ดึงข้อมูลผู้ใช้มาแก้ไขในModal
    sendInfo(id) {
      this.selectedUser = id
      axios
        .post('/fetch-userNPT', { id: this.selectedUser })
        .then(response => {
          this.editData.firstname = response.data.firstname
          this.editData.lastname = response.data.lastname
          this.editData.role = response.data.role
          this.editData.id = this.selectedUser
          this.dropdownRole()
        })
        .catch(error => {
          console.log(error)
        })
    },
    // แก้ไขข้อมูลผู้ใช้ในModal
    async editInfo() {
      const display = this.editData
      axios
        .post('/edit-userNPT', display)
        .then(response => {
          console.log(response)
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">Edit Successfully.</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error)
        })
    },
    dropdownRole() {
      axios
        .get('/dropdown-roleNPT')
        .then(response => {
          this.role = response.data
        })
    },
  },
}
</script>
